const ga = window.ga;

export default (category, event, label) => {
  ga('send', 'event', category, event, label);
};



// WEBPACK FOOTER //
// ./src/utils.js